import React, { FC } from 'react';

import { Controller } from 'react-hook-form';

import AdminTableListPage from 'components/admin/AdminTableListPage';
import { InputV2 } from 'components/common/ui-kit/Input/view';
import ReactSelect, {
  MultiValue,
  Option,
} from 'components/common/ui-kit/Select/view';
import { columnsContracts } from 'config/moderator-table';
import useAppSelector from 'hooks/common/useAppSelector';
import { useContractFilterOptions } from 'hooks/moderator/contracts/useContractFilterOptions';
import { useInitPageFilters } from 'hooks/moderator/useInitFilters';
import terms from 'i18n';
import { SelectOption } from 'models/common';
import { contractApi } from 'redux/api/applications/contract-api';
import { createInputV2Props } from 'utils/form-helpers';

import { downloadFile } from '../../../utils/common';

const ModeratorContractPageFilter = ({ control, formState: { errors } }) => {
  const inputV2Props = createInputV2Props(errors);
  const visibleFilters =
    useAppSelector(state => state.visibleFilters.contracts) ?? [];

  useInitPageFilters('contracts');

  const {
    paymentFormSelectProps,
    educationFormSelectProps,
    countrySelectProps,
    applicationStatusSelectProps,
    contractStateSelectOptions,
    facultiesFormSelectProps,
    trajectorySelectProps,
    educationProgramsSelectProps,
    moderatorSelectProps,
    serveMethodProps,
    recruitersSelectProps,
    educationLevelSelectProps,
    paymentMethod,
    contractTypeSelectOptions,
  } = useContractFilterOptions();

  return (
    <>
      {visibleFilters.includes('userId') && (
        <Controller
          name="userId"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="ID СПБПУ / ID ЕПГУ абитуриента"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
      )}

      {visibleFilters.includes('lastName') && (
        <Controller
          name="lastName"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Фамилия"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
      )}

      {visibleFilters.includes('firstName') && (
        <Controller
          name="firstName"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Имя"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
      )}

      {visibleFilters.includes('middleName') && (
        <Controller
          name="middleName"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Отчество"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
      )}

      {visibleFilters.includes('email') && (
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Email"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
      )}

      {visibleFilters.includes('directionName') && (
        <Controller
          name="directionName"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Направление"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
      )}

      {visibleFilters.includes('directionEducationFormIds') && (
        <Controller
          name="directionEducationFormIds"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={educationFormSelectProps.options}
              placeholder={terms.MODE_OF_STUDY}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('citizenshipCountryIds') && (
        <Controller
          name="citizenshipCountryIds"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              placeholder={terms.CITIZENSHIP}
              className="filter-form__field"
              options={countrySelectProps.options}
              {...(field as object)}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('applicationsStates') && (
        <Controller
          name="applicationsStates"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={applicationStatusSelectProps.options}
              placeholder="Статус заявления"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('contractStates') && (
        <Controller
          name="contractStates"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={contractStateSelectOptions.options}
              placeholder="Статус договора"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('educationProgram') && (
        <Controller
          name="educationProgram"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={educationProgramsSelectProps.options}
              placeholder="Программа"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('facultyIds') && (
        <Controller
          name="facultyIds"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={facultiesFormSelectProps.options}
              placeholder="Подразделение"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}
      {visibleFilters.includes('serveMethods') && (
        <Controller
          name="serveMethods"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              placeholder="Способ подачи"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option, MultiValue }}
              options={serveMethodProps.options}
            />
          )}
        />
      )}
      {visibleFilters.includes('recruitedIds') && (
        <Controller
          name="recruitedIds"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={recruitersSelectProps}
              placeholder="Партнер"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}
      {visibleFilters.includes('applicationEducationLevel') && (
        <Controller
          name="applicationEducationLevel"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={educationLevelSelectProps.options}
              placeholder="Уровень подготовки"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('applicationTrajectories') && (
        <Controller
          name="applicationTrajectories"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={trajectorySelectProps.options}
              placeholder="Приемная кампания"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}
      {visibleFilters.includes('moderatorIds') && (
        <Controller
          name="moderatorIds"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={moderatorSelectProps.options}
              placeholder="Сотрудник ПК"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}

      {visibleFilters.includes('informing') && (
        <Controller
          name="informing"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption>
              options={[
                { value: true, label: 'Да' },
                { value: false, label: 'Нет' },
              ]}
              placeholder="Информирование о зачислении"
              className="filter-form__field"
              isClearable
              {...(field as object)}
              // {...selectProps(field, {
              //   options: statusOptions,
              // })}
            />
          )}
        />
      )}
      {visibleFilters.includes('isOnline') && (
        <Controller
          name="isOnline"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption>
              options={[
                { value: true, label: 'Электронный' },
                { value: false, label: 'Бумажный' },
              ]}
              placeholder="Тип договора"
              className="filter-form__field"
              isClearable
              {...(field as object)}
            />
          )}
        />
      )}
      {visibleFilters.includes('signedContractReceived') && (
        <Controller
          name="signedContractReceived"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption>
              options={[
                { value: true, label: 'Да' },
                { value: false, label: 'Нет' },
              ]}
              placeholder="Контракт получен с подписью"
              className="filter-form__field"
              isClearable
              {...(field as object)}
            />
          )}
        />
      )}
      {visibleFilters.includes('contractCopyGivenToApplicant') && (
        <Controller
          name="contractCopyGivenToApplicant"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption>
              options={[
                { value: true, label: 'Да' },
                { value: false, label: 'Нет' },
              ]}
              placeholder="Экземпляр контракта передан абитуриенту"
              className="filter-form__field"
              isClearable
              {...(field as object)}
            />
          )}
        />
      )}
      {visibleFilters.includes('paymentMethods') && (
        <Controller
          name="paymentMethods"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={paymentMethod.options}
              placeholder="Особенности оплаты"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}
      {visibleFilters.includes('contractTypes') && (
        <Controller
          name="contractTypes"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption, true>
              isMulti
              styles={{
                valueContainer: provided => ({
                  ...provided,
                  maxHeight: '30px',
                  overflowY: 'auto',
                }),
                menu: base => ({ ...base, minWidth: '300px' }),
              }}
              className="filter-form__field"
              {...(field as object)}
              options={contractTypeSelectOptions.options}
              placeholder="Плательщик"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              allowSelectAll={true}
              components={{ Option, MultiValue }}
            />
          )}
        />
      )}
      {visibleFilters.includes('hasClaim') && (
        <Controller
          name="hasClaim"
          control={control}
          render={({ field }) => (
            <ReactSelect<SelectOption>
              options={[
                { value: true, label: 'Да' },
                { value: false, label: 'Нет' },
              ]}
              placeholder="Претензия поступающего"
              className="filter-form__field"
              isClearable
              {...(field as object)}
            />
          )}
        />
      )}
    </>
  );
};

export const renderContractsFilter = props => (
  <ModeratorContractPageFilter {...props} />
);

const ModeratorContractPage: FC = () => {
  const [downloadAsCSV] = contractApi.useLazyGetAllAsCsvQuery();
  return (
    <AdminTableListPage
      storeKey="contracts"
      title="Договоры"
      query={{
        use: contractApi.useGetAllQuery,
        mapQueryResultToData: data =>
          data.map(contract => ({
            ...contract,
            prettyUserId:
              contract?.userIdWithPrefix +
              ' / ' +
              (contract?.epguUniqueCodeProfile
                ? contract?.epguUniqueCodeProfile
                : '-'),
          })),
      }}
      columns={columnsContracts}
      filtersConfig={{
        defaultValues: {
          userId: '',
          lastName: '',
          firstName: '',
          middleName: '',
          email: '',
          directionPaymentTypeIds: undefined,
          directionEducationFormIds: undefined,
          citizenshipCountryIds: undefined,
          applicationsStates: undefined,
          contractStates: undefined,
          facultyIds: undefined,
          applicationTrajectories: undefined,
          informing: undefined,
          signedContractReceived: undefined,
          contractCopyGivenToApplicant: undefined,
          claim: undefined,
        },
        renderFilters: renderContractsFilter,
        mapFiltersToRequest: (filters, map) => {
          const request = {
            ...filters,
          };

          for (const filter in request) {
            if (
              Array.isArray(request[filter]) &&
              request[filter].length === 0
            ) {
              delete request[filter];
            } else if (request[filter] === '') {
              delete request[filter];
            }
          }

          return map(request);
        },
        onDownloadCsvButtonClick: ({ sorting, request }) =>
          downloadAsCSV({
            orderBy: sorting?.name,
            orderDirection: sorting?.type,
            request,
          })
            ?.unwrap()
            .then(result => {
              downloadFile(new File([result], 'Выборка_(договоры).csv'));
            }),
      }}
      sortingConfig={{
        options: [
          { label: 'по дате', value: 'CREATED_AT' },
          { label: 'по ФИО', value: 'NAME' },
        ],
      }}
      shouldOpenInNewTab
      filterSettingsPageKey="contracts"
    />
  );
};

export default ModeratorContractPage;
